// app/javascript/controllers/account_type_description_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description"]

  connect() {
    this.updateDescription()
  }

  updateDescription() {
    if (!this.hasSelectTarget) return

    const selectedOption = this.selectTarget.selectedOptions[0]
    if (!selectedOption) return

    const description = selectedOption.dataset.description || ""
    this.descriptionTarget.textContent = description
  }
}
